/**
 * TopPagesTable — top 10 paths by page.view count in the current
 * window. Renders EmptyState when the server returned an empty list.
 */
import React from "react";
import EmptyState from "./EmptyState";

export default function TopPagesTable({ rows, firstRollupDate }) {
  const safeRows = Array.isArray(rows) ? rows : [];
  if (safeRows.length === 0) {
    return (
      <EmptyState
        firstRollupDate={firstRollupDate}
        variant="card"
        testId="analytics-top-pages-empty"
      />
    );
  }

  return (
    <table
      className="w-full text-sm"
      data-testid="analytics-top-pages-table"
    >
      <thead>
        <tr
          className="border-b text-left text-[11px] font-bold uppercase tracking-[0.06em]"
          style={{
            borderColor: "var(--pp-border)",
            color: "var(--pp-text-soft)",
          }}
        >
          <th className="py-2 pr-4">Path</th>
          <th className="py-2 text-right">Visits</th>
        </tr>
      </thead>
      <tbody>
        {safeRows.map((r) => (
          <tr
            key={r.path}
            className="border-b last:border-b-0"
            style={{ borderColor: "var(--pp-border)" }}
            data-testid={`analytics-top-pages-row-${r.path}`}
          >
            <td
              className="py-2 pr-4 truncate max-w-[280px]"
              style={{ color: "var(--pp-text)" }}
            >
              {r.path || "(unknown)"}
            </td>
            <td
              className="py-2 text-right font-medium tabular-nums"
              style={{ color: "var(--pp-text)" }}
            >
              {(r.count || 0).toLocaleString("en-US")}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
